<!--
 * @Author: LiuXin
 * @Date: 2021-12-01 14:33:49
 * @LastEditors: LiuXin
 * @LastEditTime: 2021-12-29 18:31:49
-->
<template>
  <div @mousedown="e => e.preventDefault()" class="cascader-select-wrapper" ref="CascaderSelect">
    <a-select class="w100" :disabled="selectedList2.length == 100" :placeholder="'请选择' + cascaderSelectPlaceholders[1]" dropdown-class-name="select-empty">
      <template #notFoundContent>
        <a-spin :spinning="spining.visible" class="w100 h100">
          <div ref="selectEmpty" class="select-list">
            <a-select @change="val => selectChange1(val)" :value="selectedList1" :get-popup-container="getContainer('selectEmpty')" allow-clear style="margin-right: 10px" :placeholder="'请选择' + cascaderSelectPlaceholders[0]" mode="multiple" :max-tag-count="1" label-in-value v-bind="$filterOptions" option-label-prop="label" :open="dropdownVisible1" @focus="dropdownVisible1 = true" :filter-option="filterOption">
              <a-select-option v-for="item in selectData1" :key="item.value" :label="item.label" :value="item.value">
                <div class="group-item">
                  <a-checkbox @change="e => checkboxChange(e, item, 'select1')" :indeterminate="getIndeterminate(item)" :checked="getChecked(item, 'selectedList1')"> </a-checkbox>
                  <div @click.stop="getSecondListData(item)" class="option-content">
                    <div class="option-text">
                      <p :title="item.label" class="option-label">{{ item.label }}</p>
                      <p class="option-key">id：{{ item.value }}</p>
                    </div>
                    <RightOutlined class="right-icon" />
                  </div>
                </div>
              </a-select-option>
              <template #notFoundContent>
                <a-empty :image="simpleImage">
                  <template #description>
                    <span>暂无数据</span>
                  </template>
                </a-empty>
              </template>
            </a-select>
            <a-select :value="selectedList2" :get-popup-container="getContainer('selectEmpty')" allow-clear :placeholder="'请选择' + cascaderSelectPlaceholders[1]" mode="multiple" :max-tag-count="1" label-in-value v-bind="$filterOptions" option-label-prop="label" ref="select2" :open="dropdownVisible2" @focus="dropdownVisible2 = true" :filter-option="filterOption">
              <a-select-option v-for="item in selectData2" :key="item.value" :label="item.label" :value="item.value">
                <div class="group-item">
                  <a-checkbox @change="e => checkboxChange(e, item, 'select2')" :checked="getChecked(item, 'selectedList2')"> </a-checkbox>
                  <div @click.stop class="option-content">
                    <div class="option-text">
                      <p :title="item.label" class="option-label">{{ item.label }}</p>
                      <p class="option-key">id：{{ item.value }}</p>
                    </div>
                    <RightOutlined class="right-icon" />
                  </div>
                </div>
              </a-select-option>
              <template #notFoundContent>
                <a-empty :image="simpleImage">
                  <template #description>
                    <span>暂无数据</span>
                  </template>
                </a-empty>
              </template>
            </a-select>
          </div>
        </a-spin>
      </template>
    </a-select>
  </div>
</template>

<script>
import { RightOutlined } from '@ant-design/icons-vue';
import { Empty } from 'ant-design-vue';

export default {
  name: 'CascaderSelect',
  components: { RightOutlined },
  emits: ['getSecondListData', 'update:selectedList1', 'update:selectedList2'],
  props: {
    selectSource: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectedList1: {
      type: Array,
      default: function () {
        return [];
      },
    },
    selectedList2: {
      type: Array,
      default: function () {
        return [];
      },
    },
    labels: {
      type: Array,
      default: function () {
        return ['label', 'label'];
      },
    },
    keys: {
      type: Array,
      default: function () {
        return ['value', 'value'];
      },
    },
    cascaderSelectPlaceholders: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
      dropdownVisible1: false,
      dropdownVisible2: false,
      spining: { visible: false },
      currentSelectedData1: {},
    };
  },
  computed: {
    selectData1() {
      return this.selectSource[0] || [];
    },
    selectData2() {
      return this.selectSource[1] || [];
    },
  },
  methods: {
    // 获取下拉菜单父级容器
    getContainer(name) {
      const dom = this.$refs[name] || document.body;
      const fun = () => dom;
      return fun;
    },
    // 选择框改变
    checkboxChange(e, option, type) {
      const status = e.target.checked;
      if (type == 'select1') {
        option.indeterminate = false;
        // 设置选择框2的全选和反选
        let newSelectedList2 = [];
        if (status) {
          newSelectedList2 = [...this.selectedList2];
          const selectedIds = this.selectedList2.map(item => item.value);
          this.selectData2.forEach(item => {
            if (!selectedIds.includes(item.value) && item.parentId == option.value) {
              newSelectedList2.push(item);
            }
          });
          if (newSelectedList2.length >= 100) {
            newSelectedList2 = newSelectedList2.slice(0, 100);
          }
        } else {
          newSelectedList2 = this.selectedList2.filter(item => item.parentId != option.value);
        }
        this.$emit('update:selectedList2', newSelectedList2);
      } else if (type == 'select2') {
        let newSelectedList2 = [];
        if (status) {
          newSelectedList2 = [...this.selectedList2];
          newSelectedList2.push(option);
        } else {
          newSelectedList2 = this.selectedList2.filter(item => item.value != option.value);
        }
        this.$emit('update:selectedList2', newSelectedList2);

        // 如果select2全选而对应的select1未选中，则设置为已选中
        this.$nextTick(() => {
          if (status) {
            const arr1 = this.selectedList2.map(item => item.value) || [];
            const arr2 = this.selectData2.map(item => item.value) || [];
            const intersection = this.getIntersection(arr1, arr2);
            if (intersection.length && intersection.length == this.selectData2.length) {
              if (!this.currentSelectedData1.checked) {
                const list = this.selectedList1;
                list.push(this.currentSelectedData1);
                this.selectChange1(list);
              }
            }
          }
        });
      }
    },
    // 获取选中状态
    getChecked(option, listName) {
      const list = this[listName].map(item => item.value);
      const flag = list.includes(option.value);
      option.checked = flag;
      return flag;
    },
    // 选择框下拉项改变
    selectChange1(val) {
      this.$emit('update:selectedList1', val);
    },
    // 筛选
    filterOption(inputValue, option) {
      return `${option?.value}`.includes(inputValue) || `${option?.label}`.includes(inputValue);
    },
    // 设置部分选中状态
    getIndeterminate(option) {
      const value = option.value;
      let flag = false;
      if (this.selectData2[0]?.parentId != value) {
        flag = option.indeterminate ?? false;
      } else {
        // (至少包含一个)
        const arr1 = this.selectedList2.map(item => item.value) || [];
        const arr2 = this.selectData2.map(item => item.value) || [];
        const intersection = this.getIntersection(arr1, arr2);
        flag = intersection.length && intersection.length < this.selectData2.length;
      }
      option.indeterminate = flag;
      return Boolean(flag);
    },
    //获取第二联级数据
    getSecondListData(option) {
      this.spining.visible = true;
      this.dropdownVisible2 = true;
      this.currentSelectedData1 = option;
      this.$emit('getSecondListData', { ...option, spining: this.spining });
    },
    // 获取数组交集
    getIntersection(a, b) {
      const s = new Set(b);
      return [...new Set(a)].filter(x => s.has(x));
    },
  },
};
</script>

<style lang="less">
.select-empty {
  width: 600px !important;
  height: 315px;
  display: inline-block;
  .select-list {
    height: 380px;
    & > .ant-select {
      width: calc(50% - 5px);
    }
    & > :nth-child(3),
    & > :nth-child(4) {
      top: 34px !important;
      height: calc(100% - 30px);
      & > div {
        height: 100%;
        & > .ant-select-dropdown {
          top: 0 !important;
          height: 264px;
        }
      }
    }
    // 已选择项的回显方块
    .ant-select-selection-item {
      max-width: calc(100% - 63px);
    }
    .ant-select-item {
      padding: 0 12px;
      .group-item {
        width: 100%;
        margin: 0;
        display: flex;
        align-items: center;

        .ant-checkbox-wrapper {
          align-self: flex-start;
        }
        .option-content {
          width: calc(100% - 20px);
          display: flex;
          align-items: center;
          .option-text {
            width: calc(100% - 20px);
            margin: 0 5px;
            height: 40px;
            p {
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              line-height: 20px;
              &.option-key {
                color: #b7b7b7;
                size: 12px;
              }
            }
          }
          .right-icon {
            color: #666;
            float: right;
          }
        }
      }
    }
  }
}
</style>
